var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpgradePlanWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26702_12278)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0067 11.301L18.1984 9.27101C18.3484 7.67768 18.4234 6.88018 18.15 6.55101C18.0811 6.46547 17.9959 6.39441 17.8993 6.34192C17.8028 6.28943 17.6968 6.25656 17.5875 6.24518C17.1909 6.21018 16.6934 6.77685 15.6975 7.91018C15.1825 8.49685 14.925 8.78935 14.6384 8.83518C14.4783 8.86031 14.3143 8.83406 14.17 8.76018C13.9042 8.62685 13.7284 8.26435 13.3742 7.54018L11.51 3.72018C10.8417 2.35102 10.5075 1.66602 9.9992 1.66602C9.49087 1.66602 9.1567 2.35102 8.48837 3.72018L6.6242 7.54018C6.27087 8.26518 6.0942 8.62685 5.82837 8.76018C5.68393 8.83351 5.52015 8.85974 5.36004 8.83518C5.07337 8.78935 4.81587 8.49685 4.30087 7.91018C3.30504 6.77685 2.80754 6.21018 2.41087 6.24518C2.30158 6.25656 2.19561 6.28943 2.09908 6.34192C2.00254 6.39441 1.91734 6.46547 1.84837 6.55101C1.57587 6.88018 1.65087 7.67768 1.80087 9.27101L1.9917 11.301C2.3067 14.6443 2.46337 16.3168 3.45004 17.3243C4.4342 18.3327 5.91087 18.3327 8.86587 18.3327H11.1317C14.0859 18.3327 15.5625 18.3327 16.5484 17.3243C17.5342 16.316 17.6917 14.6443 18.0067 11.301Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 15H12.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26702_12278"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpgradePlanWhiteIcon);
export default __webpack_public_path__ + "static/media/UpgradePlanWhiteIcon.731a94662b0740d616639908821687c7.svg";
export { ForwardRef as ReactComponent };